
export const fkActiveObj= {
    0: '透支关阀',
    1: '缺电关阀',
    2: '干扰关阀',
    3: '远程强制关阀',
    4: '到达报警量关阀',
    5: '到达失联次数关阀',
    6: '累计用量超限关阀',
    7: '过流告警关阀',
    8: '远程关阀、阀门卡关阀',
    9: '取消强制关阀',
    10: '自动关阀/阀门自检',
    128: '刷卡开阀',
    129: '强制开阀',
    130: '远程开阀、阀门卡开阀',
    131: '自动开阀/ 阀门自检'
}
export const fkStatusObj = {
    0: '无动作',
    1: '开阀',
    2: '关阀'
}
// 联网失败原因
export const netFailReasonObj = {

}
// 故障类型
export const faultTypeObj = {
    0: '存储器故障',
    1: '阀门开故障',
    2: '阀门关故障',
    3: '磁干扰故障',
    4: '低电压故障',
    5: '高瞬时流量',
    6: '机电分离故障',
    7: '逆流告警',
    8: '过流告警',
    9: '直通用水'
}
// 命令类型
export const dataFlagObj = {
    '0':'终端参数设置','1':'查询终端参数','2':'查询基础信息','3':'历史日结信息查询','4':'阀门动作记录查询','5':'联网失败记录','6': '终端故障记录',
    '7':'查询实时数据','10': '充值','17':'强制开阀','18':'强制关阀','19':'取消阀控','20':'关阀','21':'开阀','57':'修改运行秘钥','58': '修改根秘钥'
}
// 通讯状态
export const reportStatusObj = {
    "0": "未发送","1":"正在下发","2":"已下达","3":"执行成功","4":"已取消","-1": "执行失败","-2":"过期未执行"
}
// 运营商
export const netTypeObj = {
    1: '电信OC',2:"电信AEP",3:"移动",4:"联通"
}
export const Wn100FkStatusObj = {
    0: '无阀',
    1: '无到位信号',
    2: '开阀',
    3: '关阀'
}
export const Mn100FkStatusObj = {
    0: '关阀',
    1: '开阀',
    2: '强制开阀',
    3: '强制关阀',
    4: '阀门开故障',
    5: '阀门关故障',
    6: '无阀',
    7: '阀门锈死故障',
    8: '无到位信号'
}
export const  SendWayObj = {
    0: '定时上报',
    1: '上电上报',
    2: '手动上报',
    3: '故障上报',
    4: '阀门动作上报',
    9: '读卡上报',
    6: '高频上报'
}
// 托普瑞压力表上报方式
export const  tuopuruiSendWayObj = {
    0: '定时上报',
    1: '上电上报',
    2: '手动上报',
    3: '故障上报',
    4: '事件上报',
}